import { useState, useEffect, useRef } from 'react';
import Slide from '../Slide/Slide';
import Controls from '../Controls/Controls';
import './Carousel.css';

const AUTO_INTERVAL = 5000;
const TRANSITION_DUR = 650;

const getSlideClass = (index, current, prev, direction) => {
  if (index === current) return 'carousel__slide--active';
  if (index === prev) {
    return direction === 'right' ? 'carousel__slide--exit-left' : 'carousel__slide--staged-right';
  }
  return index > current ? 'carousel__slide--staged-right' : 'carousel__slide--staged-left';
};

const Carousel = ({ slides, sectionIndex, inView }) => {
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState(null);
  const [direction, setDirection] = useState('right');
  const [busy, setBusy] = useState(false);
  const timerRef = useRef(null);

  const startTimer = (cur) => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      moveTo(cur, (cur + 1) % slides.length);
    }, AUTO_INTERVAL);
  };

  const moveTo = (from, to) => {
    if (busy || to === from || to < 0 || to >= slides.length) return;
    setBusy(true);
    setDirection(to > from ? 'right' : 'left');
    setPrev(from);
    setCurrent(to);
    setTimeout(() => {
      setBusy(false);
      setPrev(null);
    }, TRANSITION_DUR);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => moveTo(to, (to + 1) % slides.length), AUTO_INTERVAL);
  };

  useEffect(() => {
    if (inView) {
      startTimer(current);
    } else {
      clearTimeout(timerRef.current);
    }
    return () => clearTimeout(timerRef.current);
  }, [inView]);

  const FLIP_PATTERNS = [false, true, false, true];

  return (
    <div className="carousel">
      <div className="carousel__track">
        {slides.map((slide, i) => {
          const slideClass = getSlideClass(i, current, prev, direction);
          const isActive = i === current;
          const isFlipped = FLIP_PATTERNS[i % FLIP_PATTERNS.length];

          return (
            <div
              key={i}
              className={`carousel__slide ${slideClass}`}
            >
              <Slide
                slide={slide}
                isActive={isActive}
                flipped={isFlipped}
              />
            </div>
          );
        })}
      </div>

      <Controls
        current={current}
        total={slides.length}
        onPrev={() => moveTo(current, (current - 1 + slides.length) % slides.length)}
        onNext={() => moveTo(current, (current + 1) % slides.length)}
        onDotClick={(i) => moveTo(current, i)}
      />

      <div className="carousel__page-num">{String(current + 1).padStart(2, '0')}</div>
    </div>
  );
};

export default Carousel;
